<app-mf-sg-main *ngIf="isSgProduct"></app-mf-sg-main>
<mf-hk-main *ngIf="isHkProduct"></mf-hk-main>
